import React, { useState, useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { isMobile } from "react-device-detect";

import { hiddenVod } from "actions/post.action";

import { JAVASCRIPT_VOID } from "constant/config";

import { Trans } from "react-i18next";
import { CATCH } from "constant/filetype";
import i18next from "i18next";

const ClipDelete = ({ vod, close }) => {
	const dispatch = useDispatch();

	// 삭제 타입 세팅
	const [reasonDelete, setReasonDelete] = useState(false);

	// 삭제 사유 세팅
	const [reason, setReason] = useState("");

	// 삭제 버튼 비활성/활성화
	const deletable = useMemo(() => !reasonDelete || (reasonDelete && reason.length > 0), [reason.length, reasonDelete]);

	// 삭제 타입 변경
	const onChangeType = useCallback((e) => {
		const checked = e.target.checked;
		setReasonDelete(checked);
	}, []);

	// 사유 기입
	const onChangeReason = useCallback((e) => {
		let reason = e.target.value;
		if (reason.length > 200) {
			reason = reason.substr(0, 200);
		}

		setReason(reason);
	}, []);

	// 영상 숨김 처리
	const onDelete = useCallback(() => {
		if (!deletable) {
			return false;
		}

		close();
		dispatch(hiddenVod(vod.title_no, reasonDelete, reason));
	}, [close, deletable, dispatch, reason, reasonDelete, vod.title_no]);

	// 레이어 팝업 클릭 시 닫히지 않도록 처리
	const handleClickLayer = useCallback((event) => {
		event.stopPropagation();
		event.nativeEvent.stopImmediatePropagation();
	}, []);

	if (isMobile) {
		return (
			<div className="ui-pop-m vod-delete clip" onClick={handleClickLayer}>
				<div className="pop-body">
					<h2>
						<Trans>
							{vod.ucc.file_type===CATCH 
							? "Catch VOD 삭제"
							: "유저클립 VOD 삭제"
							}
						</Trans>
					</h2>
					<div className="userClipDel">
						<div className="chk-box">
							<input type="checkbox" name="" id="clipchk" checked={reasonDelete} onChange={onChangeType} />
							<label htmlFor="clipchk">
								<Trans>
									{vod.ucc.file_type===CATCH 
									? "유저 채널에서 업로드 Catch 삭제 요청"
									: "유저 채널에서 업로드 클립 삭제 요청"
									}
								</Trans>
							</label>
						</div>
					</div>
					<textarea
						name=""
						id=""
						placeholder={i18next.t("삭제 사유를 입력해주세요.")}
						disabled={!reasonDelete}
						value={reason}
						onChange={onChangeReason}
					/>
				</div>
				<div className="pop-btn">
					<a href={JAVASCRIPT_VOID} className="btn" onClick={close}>
						<Trans>취소</Trans>
					</a>
					<button type="submit" className="btn btn_blue" disabled={!deletable} onClick={onDelete}>
						<Trans>삭제</Trans>
					</button>
				</div>
			</div>
		);
	} else {
		return (
			<div className="ui-pop vod-delete clip" onClick={handleClickLayer}>
				<div className="pop-body">
					<h2>
						<sup>“</sup>
						<strong>{vod.title_name}</strong>
						<sup>”</sup>
						<span>
							<Trans>
								{vod.ucc.file_type===CATCH 
								? "Catch VOD를 삭제하시겠습니까?"
								: "유저클립 VOD를 삭제하시겠습니까?"
								}
							</Trans>

							
						</span>
					</h2>
					<div className="userClipDel">
						<div className="chk-box">
							<span>
								<input type="checkbox" name="" id="clipchk" checked={reasonDelete} onChange={onChangeType} />
								<i />
							</span>
							<label htmlFor="clipchk">
								<Trans>
									{vod.ucc.file_type===CATCH 
									? "유저 채널에서 업로드 Catch 삭제 요청"
									: "유저 채널에서 업로드 클립 삭제 요청"
									}
								</Trans>
							</label>
						</div>
					</div>
					<textarea
						placeholder={i18next.t("삭제 사유를 입력해주세요.")}
						disabled={!reasonDelete}
						value={reason}
						onChange={onChangeReason}
					/>
				</div>
				<div className="pop-btn">
					<a href={JAVASCRIPT_VOID} className="btn" onClick={close}>
						<Trans>취소</Trans>
					</a>
					<button type="submit" className="btn btn_blue" disabled={!deletable} onClick={onDelete}>
						<Trans>삭제</Trans>
					</button>
				</div>
				<a href={JAVASCRIPT_VOID} className="pop-close" onClick={close}>
					<span>레이어 닫기</span>
				</a>
			</div>
		);
	}
};

export default ClipDelete;
